<!-- Certificate -->
<div class="text-center">
    <h1 style="margin-bottom: 110px;">Housing Provider Education Certificate</h1>
    <button type="button" class="btn waves-dark w-25" (click)="createPdf()">Download PDF</button>
    <button type="button" class="btn waves-dark w-25" [routerLink]="'/courses/Fair Housing Education'">Back to Course</button>
</div>

<!--
<pdf-viewer class="test" [src]="src" [render-text]="true" [original-size]="true" style="width: 100%; height: 100%; ">
</pdf-viewer>
-->
